//import customvModelMixin from '@/mixins/custom-vmodel.mixin.js'

import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";
import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";
import { Tooltip } from "@syncfusion/ej2-popups";

Vue.use(ContextMenuPlugin);

export default {
  //  mixins: [customvModelMixin],
  props: {
    user: Object,
    navBackground: String,
    notifBellColor: String,
    externalNotification: Object,
    isDevice: Boolean
  },
  computed: {
    isMobile() {
      return Browser.isDevice;
    },
    ShouldClose() {
      return this.logoutPopup;
    },
    toggleClose() {
      return this.$store.getters.drawerVisible;
    },
    userData() {
      return this.$store.getters.userData;
    }
  },
  mounted() {
    try {
      var userData = this.$store.getters.userData;

      var names = userData.givenname.split(" ", 2);
      var initials = "";
      names.forEach((element) => {
        initials = initials + element.charAt(0).toUpperCase();
      });
      this.initials = initials;

      // initialize tooltip component
      let tooltip = new Tooltip({
        content: userData.givenname,
        position: "LeftCenter"
      });

      // render initialized tooltip
      tooltip.appendTo(this.$refs.userProfileIcon);
    } catch (error) {
      console.log(error);
    }
  },
  data() {
    return {
      menuTarget: this.$refs.userProfileIcon,
      initials: "",
      logoutPopup: false,
      iconClicked: true,
      accountList: [
        {
          text: "Editar Perfil",
          iconCss: "icon-user",
          id: "profile"
        },
        {
          text: "Cerrar Sesión",
          iconCss: "icon-lock-circled",
          id: "logout"
        }
      ],
      fields: { iconCss: "icon", tooltip: "text" }
    };
  },
  methods: {
    getOffset(el) {
      const rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      };
    },
    menuClick() {
      try {
        var el = this.$refs.userProfileIcon;
        var offset = this.getOffset(el);
        var y = pageYOffset + offset.top + el.offsetHeight;
        var x = pageYOffset + offset.left + +el.offsetWidth;
        this.$refs.contextMenu.ej2Instances.open(y, x);
        /*
        this.$refs.contextMenu.ej2Instances.open(
          event.pageY + pageYOffset + 10,
          event.pageX + pageXOffset
        );
        */
      } catch (error) {
        console.log(error);
      }
    },
    NotificationClick() {
      this.$emit("notification-clicked", 0.1);
    },
    TogglerClicked() {
      this.$emit("toggler-clicked", this.toggleClose);
    },
    LogoutClicked() {
      this.$emit("logout-clicked", 0.1);
    },
    itemSelect(e) {
      switch (e.item.id) {
        case "profile":
          this.$router.push("/profileUser");
          break;
        case "logout":
          this.$router.push("/logout");
          break;
      }
    },
    toggleNotify() {
      var notifier = !!this.externalNotification;
      if (!notifier) return;
      //this.$refs.notifybarObj.toggle();
      this.externalNotification.toggle();
      this.notifyBellClicked = true;
    },
    AccountMenu() {
      this.logoutPopup = !this.logoutPopup;
      this.iconClicked = false;
      this.$router.push("profileUser").catch((err) => {
        if (err) return;
      });
    },
    openClick() {},
    closeMenus() {
      if (this.logoutPopup && !this.iconClicked) {
        this.logoutPopup = false;
      }
      this.iconClicked = !this.iconClicked;
    },
    LoadProfile() {
      console.log("LoadProfile");
    }
  }
};
